var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aliex-swiper" }, [
    _c(
      "div",
      { staticClass: "swiper-list" },
      _vm._l(_vm.images, function(item, index) {
        return _c("div", { key: index, staticClass: "aliex-swipe" }, [
          _c("img", { attrs: { src: item, alt: "" } })
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "circle" },
      _vm._l(_vm.images.length, function(i) {
        return _c("span", { key: i, class: { active: _vm.active === i } })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-617085d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617085d2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/swiper.vue
// module id = t1pU
// module chunks = 0